<template>
    <v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs6 offset-xs3>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-layout align-center column fill-height mt-1 mb-3>
                                <h1 class="font-weight-light">{{ title }}</h1>
                                <h2 class="feature-ico"><v-icon>lock</v-icon></h2>
                                <h2 class="feature">Signing out ...</h2>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
    name: 'SignOut',
    data() {
        return {
            title: 'Sign Out'
        };
    },
    mounted() {
        this.onSignOut();
    },
    methods: {
        onSignOut() {
            this.$http
                .get('/signout', {})
                .then(() => {
                    //
                })
                .catch(err => {
                    console.error(err);
                    this.$alert({ type: 'error', title: 'Sign Out Error', message: `An error occurred trying to sign in. ${err.message}` });
                    this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
                })
                .finally(() => {
                    this.$ls.set('SignedIn', false); // Store authentication state.
                    this.$ls.set('User', null);
                    this.$ls.set('Token', null);
                    this.$http.defaults.headers.common.Authorization = null;
                    this.$root.$emit('SignedIn', false);
                    this.$router.push({ path: '/' });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/SignOut.vue